import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/compare/cargowise-alternative")({
  beforeLoad: () => {
    throw redirect({ to: "/compare/cargonova-vs-cargowise", replace: true });
  },
});
